/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CompanyOfficeListResponse } from '../../models/company-office-list-response';

export interface OfficeControllerFind$Params {
  field?: 'id' | 'name' | 'companyId' | 'email' | 'alternativeEmail' | 'address' | 'province' | 'city' | 'zipCode' | 'phoneNumber' | 'alternativePhoneNumber' | 'faxNumber' | 'countryIso' | 'officeTypes' | 'building' | 'floor' | 'directions' | 'notes';
  direction?: 'asc' | 'desc';
  query?: string;
  name?: string;
  email?: string;
  alternaticeEmail?: string;
  province?: string;
  city?: string;
  region?: string;
  addres?: string;
  zipCode?: string;
  phoneNumber?: string;
  alternativePhoneNumber?: string;
  faxNumber?: string;
  country?: string;
  companyId?: number;
  officeTypeId?: Array<number>;
  usersId?: Array<number>;
  limit?: number;
  skip?: number;
  id: number;
}

export function officeControllerFind(http: HttpClient, rootUrl: string, params: OfficeControllerFind$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerFind.PATH, 'get');
  if (params) {
    rb.query('field', params.field, {});
    rb.query('direction', params.direction, {});
    rb.query('query', params.query, {});
    rb.query('name', params.name, {});
    rb.query('email', params.email, {});
    rb.query('alternaticeEmail', params.alternaticeEmail, {});
    rb.query('province', params.province, {});
    rb.query('city', params.city, {});
    rb.query('region', params.region, {});
    rb.query('addres', params.addres, {});
    rb.query('zipCode', params.zipCode, {});
    rb.query('phoneNumber', params.phoneNumber, {});
    rb.query('alternativePhoneNumber', params.alternativePhoneNumber, {});
    rb.query('faxNumber', params.faxNumber, {});
    rb.query('country', params.country, {});
    rb.query('companyId', params.companyId, {});
    rb.query('officeTypeId', params.officeTypeId, {});
    rb.query('usersId', params.usersId, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CompanyOfficeListResponse;
      }>;
    })
  );
}

officeControllerFind.PATH = '/company/office/company/{id}';
